module.exports = __webpack_public_path__ + "img/growthAbility9.179460ab.png";